export default __webpack_public_path__ + "static/media/spinner.f2d91b61.gif";